var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-card",
        { attrs: { bordered: false } },
        [
          _c(
            "a-tabs",
            { attrs: { "default-active-key": "1" } },
            [
              _c(
                "a-tab-pane",
                { key: "1", attrs: { tab: "代收测试" } },
                [_c("pay-in-test")],
                1
              ),
              _c(
                "a-tab-pane",
                { key: "2", attrs: { tab: "代付测试" } },
                [_c("pay-out-test")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }